export const staticValueMap = {
  DriverLicense: {
    1: "NV-nin sahibi",
    2: "Yol vərəqəsi əsasında",
    3: "Hüququ olmayan şəxs",
    4: "Sahibi yanında (canlı etibarnamə)",
    5: "Etibarnamə",
    6: "Sürücülük hüququ yoxdur"
  },

  PolicyType: {
    1: "Avtonəqliyyat",
    2: "Əmlak",
    3: "Həyat sığortası",
  },

  Victim: {
    1: "Sığortalı",
    2: "Qarşı tərəf",
    3: "Naməlum",
  }
};